/* import __COLOCATED_TEMPLATE__ from './edit-device-nicename.hbs'; */
import Component from '@ember/component';
import { closeModal } from 'sh-www/utils/modal-controls';
import { inject as service } from '@ember/service';

export default Component.extend({
  store: service(),
  deviceCommands: service('commands.device-commands'),

  tagName: '',

  /**
   * @type {string}
   */
  niceName: '',

  /**
   * @type {string}
   */
  errorMessage: '',

  actions : {
    /**
     *
     */
    handleNiceNameInput(value) {
      this.set('niceName', value);
    },

    /**
     *
     */
    onSubmit() {

      this.deviceCommands.update(this.model, {
        niceName: this.niceName,
      }).then((response) => {
        this.store.pushPayload(response);
        this.model = this.store.peekRecord('device', response.data.id);

        this.set('errorMessage', '');
        closeModal(this);
      }).catch(() => {
        this.set('errorMessage', 'Error saving the device name. Make sure your Device Name is less than 50 characters and try again.');
      });
    },

    /**
     * Need to manually call cancel to clean up form
     */
    onCancel() {
      this.set('errorMessage', '');
      closeModal(this);
    },

    /**
     * Called when the modal is ready.  We need to clean up the state since it's a global object
     */
    onReady: function() {
      if (this.get('errorMessage') !== '')  {
        //user needs to correct an error, don't clear
        return;
      }

      this.set('niceName', this.get('model.niceName'));
    }
  }
});
